import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { TopBar } from "@/components/landing/TopBar";
import { Hero } from "@/components/landing/Hero";
import { Pillars } from "@/components/landing/Pillars";
import { Cohorts } from "@/components/landing/Cohorts";
import { Mentors } from "@/components/landing/Mentors";
import { Venue } from "@/components/landing/Venue";
import { Testimonials } from "@/components/landing/Testimonials";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="bg-[#faf9f5] text-stone-900 antialiased selection:bg-emerald-900 selection:text-white min-h-screen" data-testid="landing-page">
      <TopBar />
      <main>
        <Hero />
        <Pillars />
        <Cohorts />
        <Mentors />
        <Venue />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
